<!-- 请勿删除 -->
<template>
  <div style="text-align:center;padding-top:30px;">
    <div>vConsole开关: </div>
    <div><van-switch v-model="checked" /></div>
    <div style="margin-top:30px;">
      <van-button type="primary" @click="goBackHandler">
        返回上一页
      </van-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TEST',
    data() {
      return {
        checked: false
      }
    },
    watch: {
      checked(val) {
        localStorage.setItem('vconsole', val)
      }
    },
    mounted() {
      let is_console = localStorage.getItem('vconsole');
      if (is_console && is_console === 'true') {
        this.checked = true;
      }
    },
    methods: {
      goBackHandler() {
        this.$router.back(-1);
      }
    }
  }
</script>
